import React from 'react';
import SocialLinks from './components/SocialLinks';
import { shopRoot as shopUrl } from '../../env.config';


export var footerMenu = [
    {
        subheader: 'Main Menu', items: [
            { link: "/about-us/", label: "About" },
            { link: "/featured-products/", label: "Products" },
            { link: "/services/", label: "Our Services" },
            { link: "/contact/", label: "Contact Us" },
            { link: "/blog/", label: "Blog" },
            { link: "/careers/", label: "Careers" },
        ]
    },
    {
        subheader: 'Support', items: [
            { link: shopUrl, label: "Member Login" },
            { link: "/locations", label: "Design Centers (CAN)" },
            { link: "/sitemap", label: "Sitemap" },
            { link: "https://land.directbuy.com/subscribe/", label: "Email Management" },
            { link: "/company/privacy-policy", label: "Privacy Policy" },
            { link: "/company/policies-and-guidelines/effective-communication-policy", label: "Communication Policy" },
        ]
    },
    {
        subheader: 'Contact Us', items: [
            { label: "concierge@directbuy.com" },
            { label: "8450 Broadway" },
            { label: "Merrillville, Indiana 46410" },
            { link: "tel: +18447686945", label: "(844) 768-6945" },
        ]
    },
    {
        subheader: 'Follow Us', items: [
            { component: SocialLinks },
            { label: "We're socializing!" },
        ]
    },
];

export var bottomNavItems = [
    { link: shopUrl, label: "Shop" },
    { link: "/services/", label: "Service" },
    { link: "/blog/", label: "Blog" },
    { link: "/about-us/", label: "About" },
    { link: "/contact/", label: "Support" },
];
